'use es6';

export default function ({
  fetch,
  payload,
  requestActions
}) {
  return dispatch => {
    dispatch(requestActions.request(payload));
    return fetch(payload).then(resp => {
      dispatch(requestActions.receive(resp, payload));
    }).catch(err => {
      dispatch(requestActions.failure(err, payload));
      throw err;
    });
  };
}